import { render, staticRenderFns } from "./ring1.vue?vue&type=template&id=29121145&scoped=true&"
import script from "./ring1.vue?vue&type=script&lang=js&"
export * from "./ring1.vue?vue&type=script&lang=js&"
import style0 from "./ring1.vue?vue&type=style&index=0&id=29121145&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29121145",
  null
  
)

export default component.exports